import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class PageSplash extends Component {
	  	
	render () {
		
		let block = this.props.block;
		
		if (block) {
						
		    return (
			    
				<div className="c-page__block c-page__block--splash">
					
					<div className="c-splash">
					
						<div className="c-splash__inner">
														
							{block.src &&
								<Image src={block.src} srcset={block.srcset} />
							}
							
							{block.video &&
								<Cinemagraph src={block.video} />
							}
						
						</div>
												
						<div className="c-splash__tagline">
							<h2 className="c-splash__tagline__text" dangerouslySetInnerHTML={{__html:'Architecture and Interiors'}}></h2>
						</div>
						
					</div>	
					
				</div>
				
			)
			
		} else {
			
			return null;
		
		}
	}
}
